var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card w-20r"},[_c('p',{staticClass:"text-dark font-weight-bold fs-lg--1",domProps:{"innerHTML":_vm._s(_vm.text)}}),_c('h4',{staticClass:"text-primary font-poppins-semibold"},[_vm._v(_vm._s(_vm.value))])])])}
var staticRenderFns = []

export { render, staticRenderFns }